import React, { type ReactNode } from 'react';

import {
    ButtonAction,
    Content,
    LinkAction,
    StyledSettingsAction,
    StyledSettingsActionGroup,
} from './DepGroupHeader.style';

export interface DepSettingsActionGroupProps {
    children: ReactNode;
    slim?: boolean;
}

export interface DepSettingsActionProps {
    content: string;
    ariaLabel?: string;
    destructive?: boolean;
    fullWidth?: boolean;
    slim?: boolean;
    url?: string;
    referrer?: string;
    disabled?: boolean;
    onAction?(): void;
}

export function DepSettingsActionGroup({ children, slim = false }: DepSettingsActionGroupProps) {
    return <StyledSettingsActionGroup $slim={slim}>{children}</StyledSettingsActionGroup>;
}

export function DepSettingsAction({
    content,
    ariaLabel,
    destructive = false,
    fullWidth = false,
    slim = false,
    url,
    referrer,
    onAction,
    disabled = false,
}: DepSettingsActionProps) {
    const contentMarkup = <Content>{content}</Content>;
    const linkTo = { pathname: url, state: { referrer } };

    const actionMarkup = url?.length ? (
        <LinkAction to={linkTo}>{contentMarkup}</LinkAction>
    ) : (
        <ButtonAction disabled={disabled} aria-label={ariaLabel} onClick={onAction}>
            {contentMarkup}
        </ButtonAction>
    );

    return (
        <StyledSettingsAction $destructive={destructive} $fullWidth={fullWidth} $slim={slim}>
            {actionMarkup}
        </StyledSettingsAction>
    );
}
